/*
 * Copyright (C) 2017 Spanning Cloud Apps LLC.  All rights reserved.
 */
import './metadataRestoreDetails.tpl.html';

/**
 * Module for the metadataRestoreDetails.
 */
angular
  .module('batch.metadataRestore.details', [])
  /**
   * Controller for the MetadataRestoreDetails template.
   */
  .controller(
    'MetadataRestoreDetailsCtrl',
    function (
      $scope,
      $filter,
      $timeout,
      $rootScope,
      httpMetadataRestore,
      pagingUtils,
      batchErrors,
      batchUtils,
      BATCH_RESULTS,
      METADATA_RESTORE_BATCH_RESULT_TABS
    ) {
      $scope.batchErrors = batchErrors;
      $scope.successfulRestoredRecords = [];
      $scope.initialLoad = true;
      $scope.resultTabs = METADATA_RESTORE_BATCH_RESULT_TABS;
      $scope.instanceUrl = $rootScope.instanceUrl;

      // object used to track the difference properties that drive the table.
      $scope.headerValues = {
        name: 'sfName',
        id: 'id',
        type: 'type',
        result: 'result'
      };
      // property used to order the data in the table.  It must match one of the keys from the headerValues obj.
      $scope.predicate = $scope.headerValues.name;

      var batchId = $scope.batchUtils.currentBatch.batchId;

      // Show the loading mask during server requests
      $scope.$watch(
        function () {
          return batchUtils.requestsInProgress;
        },
        function (newVal, oldVal) {
          if (newVal !== oldVal) {
            $rootScope.showLoadingMask = newVal > 0;
          }
        }
      );

      /**
       * Utility to retrieve the records with the current parameters and update
       * the data on the page.
       */
      $scope.getCounts = function () {
        httpMetadataRestore.getSucessfulTypeTotals(batchId).then(function (results) {
          $scope.successfulRestoredTypes = results;
          $scope.initialLoad = false;
          if ($scope.$parent) {
            $scope.$parent.showLoadingMask = false;
          }
        });
      };

      $scope.getCounts();

      /**
       * Sets the sort parameter to the header selected.
       *
       * @param {string} header - The header value and property to sort by.
       */
      $scope.selectHeader = function (header) {
        $scope.reverse = !$scope.reverse;
        $scope.pagingParam.sortBy = header;
        $scope.pagingParam.ascending = $scope.reverse;
        pagingUtils.updateMetadataRestoreDetails($scope.pagingParam);
        // Update the records;
        if (!$scope.initialLoad) {
          $scope.updateRecords();
        }
      };

      /**
       * Returns boolean whether to show up or down arrow for header.
       *
       * @param {string} header - The header value.
       * @returns {string} - The class to use.
       */
      $scope.isSelectedHeader = function (header) {
        var headerClass = '';
        if ($scope.pagingParam.sortBy === header) {
          if (!$scope.reverse) {
            headerClass = 'sbsf-log-header-desc sca-icon-down-black';
          } else {
            headerClass = 'sbsf-log-header-asc sca-icon-down-black';
          }
        }
        return headerClass;
      };
    }
  )
  .controller('MetadataRestoreDetailsRowCtrl', function ($scope, $filter, $rootScope, batchUtils) {
    var nextPageNum = 0;
    $scope.showMessages = false;
    $scope.restoredRecords = [];

    /**
     * Returns boolean whether to show up or down arrow for error message container.
     * @returns {string} - The class to use.
     */
    $scope.isExpanded = function () {
      var headerClass = '';
      if ($scope.showMessages) {
        headerClass = 'sbsf-log-header-asc sca-icon-down-black';
      } else {
        headerClass = 'sbsf-log-header-desc sca-icon-down-black';
      }
      return headerClass;
    };

    /**
     * Function used to get next 10 records for batch.
     */
    $scope.getNextRecords = function () {
      batchUtils
        .getMetadataRecords(batchUtils.currentBatch.batchId, $scope.component, nextPageNum)
        .then(function (records) {
          $scope.restoredRecords = $scope.restoredRecords.concat(records);
          nextPageNum++;
        });
    };

    /**
     * Function used to hide the record container.
     */
    $scope.hideMessage = function () {
      $scope.showMessages = !$scope.showMessages;

      // lazy load the records
      if ($scope.showMessages && $scope.restoredRecords.length === 0) {
        $scope.getNextRecords();
      }
    };
  })
  .controller('MetadataRestoreDetailsErrorRowCtrl', function ($scope, $filter, $rootScope, batchUtils, ERROR_TYPES) {
    var nextPageNum = 0;
    var isBatchLevelError = false;
    var batchLevelErrorMsg;

    $scope.showMessages = false;
    $scope.erroredRecords = [];

    $scope.errorType = ERROR_TYPES[$scope.code].type ? $filter('i18n')(ERROR_TYPES[$scope.code].type) : '';
    $scope.description = ERROR_TYPES[$scope.code].description
      ? $filter('i18n')(ERROR_TYPES[$scope.code].description)
      : '';

    /**
     * Returns boolean whether to show up or down arrow for error message container.
     * @returns {string} - The class to use.
     */
    $scope.isExpanded = function () {
      var headerClass = '';
      if ($scope.showMessages) {
        headerClass = 'sbsf-log-header-asc sca-icon-down-black';
      } else {
        headerClass = 'sbsf-log-header-desc sca-icon-down-black';
      }
      return headerClass;
    };

    /**
     * Function used to get next 10 errored records for batch.
     */
    $scope.getNextRecords = function () {
      if (isBatchLevelError) {
        // If this is a known batch level error, we're going to get the failure records
        batchUtils.getBatchLevelRestoreFailures(batchUtils.currentBatch.batchId, nextPageNum).then(function (result) {
          $scope.count = result.count;

          // For display purposes, apply the batch level error message to each result record
          _.each(result.rows, function (row) {
            row.message = batchLevelErrorMsg;
          });

          $scope.erroredRecords = $scope.erroredRecords.concat(result.rows);
          nextPageNum++;
        });
      } else {
        // Either this is not a batch level error or we don't know yet
        batchUtils.getBatchEvents(batchUtils.currentBatch.batchId, $scope.code, nextPageNum).then(function (records) {
          // If the first page contains a single record of type BATCH_LEVEL, we're going to get the failure records
          if (!isBatchLevelError && nextPageNum === 0 && _.size(records) === 1 && records[0].type === 'BATCH_LEVEL') {
            // Save the message so we can attach it to each detail error
            batchLevelErrorMsg = records[0].message;
            // Retry and take separate code path
            isBatchLevelError = true;
            $scope.getNextRecords();
          } else {
            $scope.erroredRecords = $scope.erroredRecords.concat(records);
            nextPageNum++;
          }
        });
      }
    };

    /**
     * Function used to hide the error message container.
     */
    $scope.hideMessage = function () {
      $scope.showMessages = !$scope.showMessages;

      // lazy load the records
      if ($scope.showMessages && $scope.erroredRecords.length === 0) {
        $scope.getNextRecords();
      }
    };
  })
  /**
   * The directive for the metadataRestore details row. The record is the record object of the row.
   */
  .directive('metadataRestoreDetailsRow', function () {
    return {
      templateUrl: 'batch/metadataRestore/details/metadataRestoreDetailsRow.tpl.html',
      scope: {
        component: '=',
        count: '='
      },
      controller: 'MetadataRestoreDetailsRowCtrl'
    };
  })
  /**
   * The directive for the metadataRestore details row. The record is the record object of the row.
   */
  .directive('metadataRestoreDetailsErrorRow', function () {
    return {
      templateUrl: 'batch/metadataRestore/details/metadataRestoreDetailsErrorRow.tpl.html',
      scope: {
        code: '=',
        count: '='
      },
      controller: 'MetadataRestoreDetailsErrorRowCtrl'
    };
  });
